import { IconNames } from "../../Foundation/Icons";

export enum ButtonTypes {
    TextButton = "TextButton",
    IconButton = "IconButton",
    IconButtonBackground = "IconButtonBackground",
    LabelledIconButton = "LabelledIconButton",
}

export enum ButtonShapes {
    TextButtonRounded = "Rounded",
    TextButtonRect = "Rectangle",
}

interface Button {
    label: string;
    onClick?: () => void;
    disabled?: boolean;
    ariaPressed?: boolean;
}

export interface TextButtonProps extends Button {
    type: ButtonTypes.TextButton;
    variant?: "filled" | "outlined";
    shape?: ButtonShapes.TextButtonRect | ButtonShapes.TextButtonRounded;
    ariaPressed?: boolean;
}

export interface IconButtonProps extends Button {
    type: ButtonTypes.IconButton;
    name: IconNames;
    variant?: "light" | "dark";
    size?: string;
    background?: boolean;
    iconTitle?: string;
    ref?: React.Ref<HTMLButtonElement>;
}

export interface LabelledIconButtonProps extends Button {
    type: ButtonTypes.LabelledIconButton;
    name: IconNames;
    size?: string;
    orientation?: "horizontalNav" | string;
    theme?: string;
    iconColour?: string;
}

export type ButtonProps =
    | TextButtonProps
    | IconButtonProps
    | LabelledIconButtonProps;
